import { Coupon } from "@xapp/stentor-api-client/dist/api/plans/coupons/Coupons";

export type PlanState = {
    coupon?: Coupon;
    couponError?: string;
};
